export default __webpack_public_path__ + "static/vi-testimonial-bg-desktop-light-a706784ae23bb57a430423fb73e4316a.png";